import { Button } from '@pmi/dsm-react';
import { useEffect, useState } from 'react';
import Overlay from '../../../shared/components/Overlay';
import styles from '../logs.module.scss';
import AuditLogsTable from './AuditLogsTable';
import LogSearchField from '../LogSearchField';
import { LogSearchApiRequest } from '../apiSlice';
import useGetLogs from '../../../shared/hooks/useGetLogs';
import { SearchItemMap } from '../LogSearchField/models';

export default function AuditLogs() {
  const [initialRequest, setInitialRequest] = useState(true);
  const [search, setSearch] = useState<LogSearchApiRequest>({
    logType: '',
  });
  const [logList, setLogList] = useState([]);
  const { storedData, hasMore, handleLoadMore, isLoading } = useGetLogs(
    search,
    initialRequest,
  );
  const columns = [
    { label: 'Action', value: 'action' },
    { label: 'Action Group', value: 'logType' },
    { label: 'Triggered By', value: 'user' },
    { label: 'Triggered Against', value: 'accountUser' },
    { label: 'Reference ID', value: 'id' },
    { label: 'Agreement ID', value: 'search' },
    { label: 'Date/Time', value: 'startDate' },
  ];
  const mapColumns: SearchItemMap[] = [
    { column: 'action', with: 'action' },
    { column: 'search', with: 'search' },
    { column: 'startDate', with: 'startDate' },
    { column: 'user', with: 'user' },
  ];
  const onSearch = (searchData: { [key: string]: string } | null) => {
    if (searchData) {
      const clone: LogSearchApiRequest = { ...searchData };
      if (clone?.logType && clone.logType.length > 0) {
        clone.logType =
          clone.logType.charAt(0).toUpperCase() + clone.logType.slice(1);
      }
      if (clone?.search?.length > 0) {
        clone.searchField = 'DealId';
      }
      setLogList([]);
      setSearch(clone);
      setInitialRequest(true);
      return;
    }
    setSearch(null);
  };
  useEffect(() => {
    setLogList(storedData);
  }, [search, isLoading, storedData]);
  return (
    <>
      <LogSearchField
        onSearch={onSearch}
        columns={columns}
        mapColumns={mapColumns}
        disabled={isLoading}
      />
      <h5 className=" fw-normal fs-4 my-3">
        <strong className="fw-bold">
          <span>Audit Log</span>
        </strong>
      </h5>
      <div className={styles['card-container']}>
        {!isLoading && logList && logList?.length === 0 && (
          <p className={`${styles['no-log-msg']}`}>No audit logs available</p>
        )}
        {logList && logList?.length > 0 && <AuditLogsTable logs={logList} />}
      </div>
      {!isLoading && hasMore && logList && logList?.length > 0 && (
        <div className="text-center pt-3">
          <Button
            variant="primary"
            onClick={() => {
              setInitialRequest(false);
              handleLoadMore();
            }}
            titleText="Load More"
          />
        </div>
      )}
      <Overlay
        variant="PMIOverlay"
        global
        animated
        fade
        iconColor="brand-dark"
        overlayColor="black"
        overlayOpacity={1}
        show={isLoading}
      />
    </>
  );
}
